import React from "react";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import ValeurCards from "../sections/ValeurCards";

const Mission = ({ missions }) => {
    if (!missions || missions.length === 0) {
        return null;
    }

    return (
        <section className="py-24 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden">
            {/* Ambient Animated Background Elements */}
            <div className="absolute top-[-10%] left-[-10%] w-[30rem] h-[30rem] bg-purple-300/[0.3] rounded-full mix-blend-multiply filter blur-[100px] animate-blob"></div>
            <div className="absolute top-[20%] right-[-10%] w-[30rem] h-[30rem] bg-pink-300/[0.3] rounded-full mix-blend-multiply filter blur-[100px] animate-blob animation-delay-2000"></div>
            <div className="absolute bottom-[-20%] left-[20%] w-[30rem] h-[30rem] bg-blue-300/[0.3] rounded-full mix-blend-multiply filter blur-[100px] animate-blob animation-delay-4000"></div>

            <div className="container mx-auto px-4 z-10 relative">
                <div className="text-center mb-16 wow fadeInUp" data-wow-delay="0.1s">
                    <span className="text-purple-600 font-semibold tracking-wider uppercase text-sm mb-2 block">Nos Objectifs</span>
                    <h2 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-700 via-purple-500 to-pink-500 mb-6 tracking-tight drop-shadow-sm">
                        Notre Mission
                    </h2>
                    <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto font-light leading-relaxed">
                        Engagés pour l'excellence et guidés par notre vision d'impact. Nous travaillons sans relâche pour apporter des solutions innovantes et durables.
                    </p>
                </div>
                
                <div className="wow fadeInUp w-full" data-wow-delay="0.2s">
                    <ValeurCards data={missions} icon={faBullseye} color={'purple'} />
                </div>
            </div>
            
            <style>{`
                @keyframes blob {
                    0% { transform: translate(0px, 0px) scale(1); }
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                .animate-blob {
                    animation: blob 8s infinite cubic-bezier(0.4, 0, 0.2, 1);
                }
                .animation-delay-2000 {
                    animation-delay: 2s;
                }
                .animation-delay-4000 {
                    animation-delay: 4s;
                }
            `}</style>
        </section>
    );
};

export default Mission;